<template>
  <div class="empty-state text-center pa-8">
    <v-icon
      :size="iconSize"
      :color="iconColor"
      class="mb-4"
    >
      {{ icon }}
    </v-icon>

    <div v-if="title" class="text-h5 mb-2">{{ title }}</div>
    <div class="text-body-1 grey--text mb-4">{{ message }}</div>
    <div v-if="description" class="text-body-2 grey--text mb-4">{{ description }}</div>

    <div v-if="showActions" class="d-flex justify-center flex-wrap">
      <v-btn
        v-if="showCreate"
        :color="primaryActionColor"
        :large="largeButtons"
        class="ma-1"
        @click="onPrimaryAction"
      >
        <v-icon left>{{ primaryActionIcon }}</v-icon>
        {{ primaryActionText }}
      </v-btn>

      <v-btn
        v-if="showSecondary"
        :color="secondaryActionColor"
        :outlined="secondaryOutlined"
        :text="secondaryText"
        :large="largeButtons"
        class="ma-1"
        @click="onSecondaryAction"
      >
        <v-icon left>{{ secondaryActionIcon }}</v-icon>
        {{ secondaryActionText }}
      </v-btn>

      <v-btn
        v-if="showRefresh"
        color="grey"
        text
        :large="largeButtons"
        class="ma-1"
        @click="onRefresh"
      >
        <v-icon left>mdi-refresh</v-icon>
        Refresh
      </v-btn>
    </div>

    <!-- Custom action slot -->
    <div v-if="$slots.actions" class="mt-4">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',

  props: {
    // Content props
    title: {
      type: String,
      default: 'No Data Available',
    },
    message: {
      type: String,
      default: 'There are no items to display at this time.',
    },
    description: {
      type: String,
      default: '',
    },

    // Visual props
    icon: {
      type: String,
      default: 'mdi-database-off',
    },
    iconSize: {
      type: [Number, String],
      default: 80,
    },
    iconColor: {
      type: String,
      default: 'grey',
    },

    // Action props
    showCreate: {
      type: Boolean,
      default: true,
    },
    showSecondary: {
      type: Boolean,
      default: false,
    },
    showRefresh: {
      type: Boolean,
      default: false,
    },
    largeButtons: {
      type: Boolean,
      default: false,
    },

    // Primary action customization
    primaryActionText: {
      type: String,
      default: 'Create New',
    },
    primaryActionIcon: {
      type: String,
      default: 'mdi-plus',
    },
    primaryActionColor: {
      type: String,
      default: 'primary',
    },

    // Secondary action customization
    secondaryActionText: {
      type: String,
      default: 'Learn More',
    },
    secondaryActionIcon: {
      type: String,
      default: 'mdi-help-circle',
    },
    secondaryActionColor: {
      type: String,
      default: 'primary',
    },
    secondaryOutlined: {
      type: Boolean,
      default: true,
    },
    secondaryText: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showActions() {
      return this.showCreate || this.showSecondary || this.showRefresh || this.$slots.actions;
    },
  },

  methods: {
    onPrimaryAction() {
      this.$emit('primary-action');
    },

    onSecondaryAction() {
      this.$emit('secondary-action');
    },

    onRefresh() {
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.empty-state {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
